import { isEmpty } from '../../utils/helpers';
import * as type from '../actions/types';

const initialState = {
  data: {},
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_PAYMENT_SETTINGS_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        error: '',
      };
    case type.FETCH_PAYMENT_SETTINGS_SUCCESS:
      // Hack for paymentSettingsById returning in different structure // TODO remove this when fixed
      if (!isEmpty(action?.payload?.data?.paymentSettings?.id)) {
        return {
          ...state,
          data: {
            ...action.payload.data.paymentSettings,
            pinMode: action.payload.data.pinMode,
            publishableKey: action.payload.data.publishableKey,
          },
          pending: false,
          success: true,
          error: '',
        };
      }

      return {
        ...state,
        data: action.payload.data,
        pending: false,
        success: true,
        error: '',
      };
    case type.FETCH_PAYMENT_SETTINGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        pending: false,
        success: false,
      };
    default:
      return state;
  }
};
